module.exports = __webpack_public_path__ + "static/media/emailDeliveredIcon.648881a1.svg";